(function () {
    'use strict';
    var controllerId = 'vendorProductsCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$cookies', '$modal', vendorProductsCtrl]);

    function vendorProductsCtrl(common, datacontext, $scope, $cookies, $modal) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.startSearch = 0;
        vm.vendor_products = [];
        vm.title = 'Vendor Products View';

        vm.query = {
            search:'',
            page:1,
            limit:50
        };
        if( angular.isDefined($cookies.get('user_role_id')) ) {
          vm.user_role_id = $cookies.get('user_role_id');
          console.log("vm.user_role_id:"+vm.user_role_id);
        }
        $scope.$on('refreshVendorProductsLog', function (event, data) {

        	 activate();
        });

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    // console.log(i, newValue[i], oldValue[i]);
                    vm.startSearch ++;
                }
            }
        });

        activate();

        function activate() {
            var promises = [
                    get_vendor_product_list(),
                    get_vendor_stock_status(),
                    get_vendors(),
                    get_vendor_product_po_history()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    //log('Activated Vendor Products View');
                });
        }

        function get_vendors() {
            datacontext.get_vendors_v1().then(function (httpResult) {
                vm.get_vendors = httpResult.data.data;
            });
        }

        function get_vendor_product_list() {
            return datacontext.get_vendor_product_list({product_id:$scope.product_id}).then(function(httpResult) {
                vm.vendor_products = httpResult.data.data;
            });
        }

        function get_vendor_stock_status() {
            datacontext.get_vendor_stock_status().then(function (httpResult) {
                $scope.vendor_stock_status = httpResult.data.data;
            });
        }

        function get_vendor_product_po_history() {
        	//console.log($scope.product_id);

        	datacontext.get_vendor_product_list({product_id:$scope.product_id}).then(function(httpResult) {
                vm.vendor_products = httpResult.data.data;
                $scope.vendor_product_ids = '';
                angular.forEach(vm.vendor_products,function(value,key){
            		 angular.forEach(value,function(v1,k1){//this is nested angular.forEach loop
                    if( (k1 === 'vendor_product_id' || k1 === 'product_id') && !isNaN(v1) ){
                      $scope.vendor_product_id = v1;
                      if(($scope.vendor_product_ids+'').length > 0){
                        $scope.vendor_product_ids = $scope.vendor_product_ids + ',' + v1;
                      }else{
                        $scope.vendor_product_ids = v1;
                      }

                    }

                    });
                });
                if($scope.vendor_product_ids.length > 0){
                  datacontext.get_vendor_product_po_history({vendor_product_ids:$scope.vendor_product_ids}).then(function (httpResult) {
                    $scope.product_po_log = httpResult.data.data;
                  });
                }else{
                  datacontext.get_vendor_product_po_history({product_id:$scope.product_id}).then(function (httpResult) {
                    $scope.product_po_log = httpResult.data.data;
                  });
                }
            });


        }

        // create vendor Product
        $scope.create_vendor_product = function () {
            // Set vendor id
            var submitData = {
                vendor_id: vm.po.vendor_id,
                vendor_product_id: vm.poi.vendor_product_id,
                vendor_stock_status_id:vm.poi.vendor_id,
                vendor_sku: vm.poi.vendor_sku,
                vendor_product_line_id: vm.poi.vendor_product_line_id,
                cost: vm.poi.cost,
                inventory: vm.poi.inventory,
                product_id: vm.poi.product_id
            };

            datacontext.create_vendor_product(submitData).then(function (httpResult) {
                // Set vendor_product_id to Scope
                vm.poi.vendor_product_id = httpResult.data;
                // Now create PO item
                log('Vendor Product Created');
            });
        };

        // update vendor Product
        $scope.update_vendor_product = function (data,update_vendor_product) {
          console.log(update_vendor_product);
          console.log(data);
          if(angular.isDefined(data.cost_update)){
            var payload = {
                vendor_product_id: data.vendor_product_id,
                vendor_stock_status_id:data.vendor_stock_status_id,
                vendor_sku: data.vendor_sku,
                vendor_product_line_id: data.vendor_product_line_id,
                cost: data.cost,
                cost_update: data.cost_update,
                caselot: data.caselot,
                inventory: data.inventory,
                product_id: data.product_id,
                qty_on_hand: data.qty_on_hand,
                licensed_till: data.licensed_till,
                vp_notes: data.vp_notes
            };
          }else if(angular.isUndefined(data.vp_notes)){
            var payload = {
                vendor_product_id: data.vendor_product_id,
                vendor_stock_status_id:data.vendor_stock_status_id,
                vendor_sku: data.vendor_sku,
                vendor_product_line_id: data.vendor_product_line_id,
                cost: data.cost,
                caselot: data.caselot,
                inventory: data.inventory,
                product_id: data.product_id,
                qty_on_hand: data.qty_on_hand,
                licensed_till: data.licensed_till
            };
          }else{
            var payload = {
                vendor_product_id: data.vendor_product_id,
                vendor_stock_status_id:data.vendor_stock_status_id,
                vendor_sku: data.vendor_sku,
                vendor_product_line_id: data.vendor_product_line_id,
                cost: data.cost,
                caselot: data.caselot,
                inventory: data.inventory,
                product_id: data.product_id,
                qty_on_hand: data.qty_on_hand,
                licensed_till: data.licensed_till,
                vp_notes: data.vp_notes
            };
          }


            datacontext.update_vendor_product(payload).then(function (httpResult) {
                // Set vendor_product_id to Scope
                //vm.poi.vendor_product_id = httpResult;
                if (httpResult.data.success) {
                  $scope.updated = 1;
                  get_vendor_product_list();
                  log('Vendor Product Updated');
                }else {
                  $scope.duplicate = 1;
                  $scope.duplicate_id = httpResult.data.data;
                  $scope.attempted_sku = data.vendor_sku;
                }


            });
        };

        datacontext.get_vendors_list().then(function(httpResult) {
    		$scope.vendors = httpResult.data.data;
    	});



        // create vendor Product
        $scope.add_vendor_product = function (data) {
        	//console.log($scope);
        	console.log($scope.product);


        	console.log($scope.vendors);

        	$scope.vendor_product_create = {
                po_id:$scope.po_id,
                product_id:$scope.product_id,
                product_title:$scope.product.product_name,
                vendor_id:$scope.vendor_id,
                vendors:$scope.vendors,
                vendor_stock_status_id:1,
                cost:0
            };


            console.log('new vp163',$scope.vendor_product_create);

            // merge order item w/order items
            var modalInstance = $modal.open({
                templateUrl: '/app/vendorproducts/partials/vendor_product_create_modal.html',
                controller:"vendorProductCreateModalCtrl",
                windowClass:'large',
                resolve: {
                    vendor_product_create: function () {
                        return $scope.vendor_product_create;
                    }
                }
            }).result.then(function(new_vendor_product){
                    // create poi
            	$scope.$broadcast('refreshVendorProductsLog', 'refresh');

                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
                get_purchase_orders();
            };
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'vendorProductCreateModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','vendor_product_create', vendorProductCreateModalCtrl]);

    function vendorProductCreateModalCtrl(common, datacontext, $scope, $modalInstance, vendor_product_create) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        // Pushes input to scope
        $scope.submitted = 0;
        $scope.is_duplicate = 0;

        // Get List of vendor stock statu's for pull down
        datacontext.get_vendor_stock_status().then(function(httpResult) {
            $scope.vendor_stock_status = httpResult.data.data;
        });

        console.log('vendor_product_create', vendor_product_create);
        console.log($scope);
        // Set Product Defaults
        $scope.vproduct =
            {
                vendor_product_id:"",
                vendor_sku:"",
                vendor_id:vendor_product_create.vendor_id,
                vendors:vendor_product_create.vendors,
                product_id:vendor_product_create.product_id,
                product_title:vendor_product_create.product_title,
                po_id:vendor_product_create.po_id,
                vendor_stock_status_id:1,
                cost:0
            };
            console.log($scope.vproduct);


        // Create Vendor Products
        $scope.create_vendor_product = function(isValid) {

            $scope.submitted = 1;

            if (isValid) {
                datacontext.get_vendor_product_list({
                    vendor_id:$scope.vproduct.vendor_id,
                    vendor_sku:$scope.vproduct.vendor_sku}).then(function (httpResult) {

                    if ( httpResult.data.data.length ) {
                        // Duplicate creation just update
                        $scope.vproduct.vendor_product_id = httpResult.data.data[0].vendor_product_id;
                        $scope.isCreated = true;
                        log('Vendor Product Created1');
                        // Redirect
                        $modalInstance.close(httpResult.data.data[0]);
                    }else {
                    	//making vendor list as null
                    	$scope.vproduct.vendors = '';
                        // Create Vendor Product
                        datacontext.create_vendor_product($scope.vproduct).then(function (httpResult) {

                            $scope.vproduct.vendor_product_id = httpResult.data;
                            $scope.isCreated = true;
                            log('Vendor Product Created2');
                            // Redirect
                            $modalInstance.close($scope.vproduct);
                        });
                    }
                });
            } else{
                $scope.message_text = 'Missing Information';
            }
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'vendorProductDetailCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams','$location', '$anchorScroll', vendorProductDetailCtrl]);

    function vendorProductDetailCtrl(common, datacontext, $scope, $routeParams, $location, $anchorScroll) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.title = 'Vendor Product View';

        $scope.vendor_product_id = $routeParams.vpid;
        $scope.updated = 0;
        $scope.duplicate = 0;

        // setting for audit log
        $scope.audit_link_id = $routeParams.vpid;
        $scope.audit_type_id = 4;

        activate();

        function activate() {
            var promises = [
                get_vendor_product_list(),
                get_vendor_stock_status(),
                get_vendor_product_po_history(),
                getProductCategories(),
                get_vendors(),
                get_manufacturers()
              ];
            common.activateController(promises, controllerId)
                .then(function () {
                   // log('Activated Vendor Product View');
                });
        }

        function get_vendors() {
            datacontext.get_vendors_v1().then(function (httpResult) {
                vm.get_vendors = httpResult.data.data;
            });
        }

        function getProductCategories() {
            return datacontext.get_product_categories().then(function (httpResult) {
                vm.product_categories = httpResult.data;
            });
        }

        function get_manufacturers() {
            return datacontext.get_manufacturers().then(function (httpResult) {
                vm.manufacturers = httpResult.data;
            });
        }

        function get_vendor_product_list() {


            return datacontext.get_vendor_product_list({vendor_product_id:$scope.vendor_product_id}).then(function (httpResult) {
                vm.vproduct = httpResult.data.data[0];

                datacontext.get_vendor_product_change_log(vm.vproduct).then(function (httpResult) {
                    vm.vendor_product_change_log = httpResult.data.data;
                });

            });
        }

        function get_vendor_stock_status() {
            datacontext.get_vendor_stock_status().then(function (httpResult) {
                vm.vendor_stock_status = httpResult.data.data;
            });
        }

        function get_vendor_product_po_history() {
            datacontext.get_vendor_product_po_history({vendor_product_id:$scope.vendor_product_id}).then(function (httpResult) {
                $scope.product_po_log = httpResult.data.data;
            });
        }
        // update vendor Product
        $scope.update_vendor_product = function (data) {
          console.log(data);
          datacontext.update_vendor_product(data).then(function (httpResult) {
            // Set vendor_product_id to Scope
            if (httpResult.data.success) {
              $scope.updated = 1;
              $scope.$broadcast('refreshAuditLog', 'refresh');
              get_vendor_product_list();
              toastr.success("Vendor Product Updated");
            }else {
              $scope.duplicate = 1;
              $scope.duplicate_id = httpResult.data.data;
              $scope.attempted_sku = data.vendor_sku;
            }
          });
        };
    }
})();


(function () {
    'use strict';
    var controllerId = 'vendorProductAnalyzefillCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams','$location', 'NgTableParams', '$anchorScroll', vendorProductAnalyzefillCtrl]);

    function vendorProductAnalyzefillCtrl(common, datacontext, $scope, $routeParams, $location, NgTableParams, $anchorScroll) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;
        vm.title = 'Vendor Product List View';
        $scope.IsHidden = true;

        vm.query = {
            last_po: '3',
            queryType:'array-count',
            order_by:'vendor_product_id',
            order_dir:'desc',
            page:1,
            limit:20
        };

        vm.query.vendor_id = $routeParams.vid;
        vm.parsed = 0;

        vm.urlQuery  = $location.search();
        vm.url_used = 0;

        // loop and set url var
        for (var i in vm.urlQuery) {
            // ignore query type in url
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }

            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            vm.url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {

            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    get_vendor_products_by_vendor();
                }
            }

        });

        activate();

        function activate() {
            var promises = [
                get_vendor_products_by_vendor()
            ];

            common.activateController(promises, controllerId)
                .then(function() {
                    //log('Activated ' + vm.title);
                });
        }

        function get_vendor_products_by_vendor() {

            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;


                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    log_success("Loading");
                    // ajax request to api
                    return datacontext.get_vendor_products_by_vendor(vm.query).then(function (httpResult) {
                        //console.log("httpResult",httpResult);
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        vm.query.page = params.page;
                        vm.vendor_name = httpResult.data.vendor_name;
                        // set new data
                        log_success(vm.results_total+" Results Found");
                        vm.results = httpResult.data.data;
                        return httpResult.data.data;
                    });
                }
            });
        }

    }
})();

(function () {
    'use strict';
    var controllerId = 'vendorProductsListCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', 'NgTableParams', vendorProductsListCtrl]);
    function vendorProductsListCtrl(common, datacontext, $scope, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.vendor_products = [];
        vm.startSearch = 0;
        vm.title = 'Vendor Product List View';
        // create empty structure for search items

        vm.query = {
            queryType:'array-count',
            search:'',
            vendor_id: 1,
            vendor_stock_status_id:'',
            manufacturer_id:'',
            hasProduct:'',
            hasVendorLine:'',
            order_by:'vendor_product_id',
            order_dir:'desc',
            page:1,
            limit:50
        };

        vm.urlQuery  = $location.search();
        vm.url_used = 0;

        // loop and set url var
        for (var i in vm.urlQuery) {
            // ignore query type in url
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            vm.url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {


            for ( var i in newValue ) {

                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                	vm.startSearch ++;
                	if( oldValue[i] >= 0 || oldValue[i] == "" || angular.isUndefined(oldValue[i])  == true ){

                		vm.grid = 0;
                		get_vendor_product_list();
                	}
                }
            }
            vm.grid = 0;
        });


        activate();

        function activate() {
            var promises = [
                get_vendor_stock_status(),
                get_vendors_list(),
                get_manufacturers(),
                get_vendor_product_list()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        function get_vendor_stock_status() {
            datacontext.get_vendor_stock_status().then(function (httpResult) {
                $scope.vendor_stock_status = httpResult.data.data;
            });
        }

        function get_vendors_list() {
            return datacontext.get_vendors_list().then(function(httpResult) {
                $scope.vendors = httpResult.data.data;
            });
        }

        function get_manufacturers() {
            return datacontext.get_manufacturers().then(function (httpResult) {
                $scope.manufacturers = httpResult.data;
            });
        }

        function get_vendor_product_list() {
        	vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;


                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_vendor_product_list(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        vm.query.page = params.page;
                        // set new data
                        vm.results = httpResult.data.data;
                        vm.grid = 1;
                        return httpResult.data.data;
                    });
                }
            });
        }

    }
})();

(function () {
    'use strict';
    var controllerId = 'vendorProductImportCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope','$cookies', '$routeParams', vendorProductImportCtrl]);

    function vendorProductImportCtrl(common, datacontext, $scope, $cookies, $routeParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.vendor_id = $routeParams.vid;
        vm.parsed = 0;

        $scope.flowOptions = {
            target: '/apis/vendor_products.cfc?method=upload_vendor_products&vendor_id=' + vm.vendor_id,
            testChunks: false,
            permanentErrors: [404, 500, 501],
            maxChunkRetries: 20,
            chunkRetryInterval: 50000,
            simultaneousUploads: 1,
            singleFile: true,
            headers: {'Authorization': 'Bearer ' + $cookies.get('token')}
        };

        $scope.$on('catchAll', function () {
            //event.preventDefault();//prevent file from uploading
            console.log('catchAll', arguments);
        });

        activate();

        function activate() {
            var promises = [
                get_vendors()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Task List View');
                });
        }

        function get_vendors() {


            var payload = {
                vendor_id: vm.vendor_id
            };
            return datacontext.get_vendors(payload).then(function(httpResult) {
                $scope.v = httpResult.data.data[0];
            });
        }

        $scope.uploadResult = function (file, message, flow) {

            // parse json ???
            var msg = JSON.parse(message);
            console.log('msg', msg);
            console.log('file', file);
            console.log('flow', flow);

            vm.parsed = 1;
            $scope.status = msg.success;
            $scope.parsed_cnt = msg.data.parsed;

            $scope.skip_cnt = msg.data.skip_count;
            $scope.skip_details = msg.data.skip_array;

            $scope.error_cnt = msg.data.fail_count;
            $scope.error_details = msg.data.fail_array;
        };

    }
})();
